import {
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { Mask } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import type { IncomeReportTableProps } from './types';
import { StyledTable, StyledTableCell, StyledTableRow } from './styles';
import { renderCellContent } from './utils/renderTotalCellContent';
import { FinancialColumnId } from '../../constants/columns';

export function IncomeReportTable({
  columns,
  extract,
  total,
}: Readonly<IncomeReportTableProps>) {
  return (
    <TableContainer>
      <StyledTable aria-label="income report table">
        <TableHead>
          <TableRow>
            {columns.map(column => (
              <StyledTableCell
                key={column.id}
                columnId={column.id}
                align={column.align ?? 'left'}
              >
                <Typography
                  variant="text"
                  fontWeight={600}
                  color={NEW_COLORS.PRIMARY[400]}
                >
                  {column.label}
                </Typography>
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {extract.map(row => (
            <TableRow key={row.documentNumber}>
              {columns.map(column => (
                <StyledTableCell
                  key={column.id}
                  columnId={column.id}
                  align={column.align ?? 'left'}
                >
                  {column.id === FinancialColumnId.Amount
                    ? Mask.currency(Number(row[column.id as keyof typeof row]))
                    : row[column.id as keyof typeof row]}
                </StyledTableCell>
              ))}
            </TableRow>
          ))}

          <StyledTableRow>
            {columns.map((column, index) => (
              <StyledTableCell
                key={column.id}
                columnId={column.id}
                align={column.align ?? 'left'}
              >
                {index === 0
                  ? renderCellContent(column.id, true, total)
                  : renderCellContent(column.id, false, total)}
              </StyledTableCell>
            ))}
          </StyledTableRow>
        </TableBody>
      </StyledTable>
    </TableContainer>
  );
}
